module.exports = __webpack_public_path__ + "img/icb-co-elite-m@2x.033b351f.png";